module.exports = __webpack_public_path__ + "static/media/Optimal-Icon-01.6e6e935d.svg";